import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { SUP_VEHICLE_LIST, SUP_VEHICLE_ADD, SUP_VEHICLE_DETAIL, SUP_VEHICLE_UPDATE, SUP_VEHICLE_FILTER_TYPE, SUP_VEHICLE_FILTER_SUPPLIERS } from '../../actions';
import {
  SupplierVehicleListSuccess, SupplierVehicleListError,
  SupplierVehicleAddSuccess, SupplierVehicleAddError,
  SupplierVehicleDetailSuccess, SupplierVehicleDetailError,
  SupplierVehicleUpdateSuccess, SupplierVehicleUpdateError,
  SupplierVehicleFilterTypeSuccess,
  SupplierVehicleFilterSuppliersSuccess
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/vehicle/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/vehicle/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/vehicle/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/vehicle/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onFilterTypeAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/search/vehicle_types', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(SupplierVehicleListSuccess(response.data)); }
  catch (error) { yield put(SupplierVehicleListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(SupplierVehicleAddSuccess(response.data));
  } catch (error) { yield put(SupplierVehicleAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(SupplierVehicleDetailSuccess(response.data.data)); }
  catch (error) { yield put(SupplierVehicleDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(SupplierVehicleUpdateSuccess(response.data));
  } catch (error) { yield put(SupplierVehicleUpdateError(error)); }
}

function* onFilterType() {
  try { const response = yield call(onFilterTypeAsync); yield put(SupplierVehicleFilterTypeSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onFilterSuppliersAsync); yield put(SupplierVehicleFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(SUP_VEHICLE_LIST, onList); }
export function* watchAdd() { yield takeEvery(SUP_VEHICLE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(SUP_VEHICLE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(SUP_VEHICLE_UPDATE, onUpdate); }
export function* watchFilterType() { yield takeEvery(SUP_VEHICLE_FILTER_TYPE, onFilterType); }
export function* watchFilterSuppliers() { yield takeEvery(SUP_VEHICLE_FILTER_SUPPLIERS, onFilterSuppliers); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate), fork(watchFilterType), fork(watchFilterSuppliers)]);
}
